import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Capacitor } from '@capacitor/core';
import { AuthProvider } from '@/context/AuthContext';
import { ProtectedRoute } from '@/components/ProtectedRoute';
import { ScrollToTop } from '@/components/ScrollToTop';
import { Toaster } from '@/components/ui/sonner';
import { useCapacitor } from '@/hooks/useCapacitor';
import { SafetyButton } from '@/components/compliance';
import { PUBLIC_ROUTES, GUARDED_ROUTES } from '@/config/routes';
import { logError } from '@/lib/logger';
import '@/App.css';

function AppContent() {
  useCapacitor();

  // Register service worker for push notifications (web only)
  useEffect(() => {
    if (!Capacitor.isNativePlatform() && 'serviceWorker' in navigator) {
      navigator.serviceWorker.register('/sw.js').catch((err) => {
        logError('Service worker registration failed (non-critical):', err);
      });
    }
  }, []);

  return (
    <>
      <ScrollToTop />
      <Routes>
        {PUBLIC_ROUTES.map(({ path, Component }) => (
          <Route key={path} path={path} element={<Component />} />
        ))}
        {GUARDED_ROUTES.map(({ path, Component, guard }) => (
          <Route
            key={path}
            path={path}
            element={
              <ProtectedRoute {...guard}>
                <Component />
              </ProtectedRoute>
            }
          />
        ))}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <SafetyButton />
      <Toaster position="top-center" richColors />
    </>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
